<div class="bg-light pb-8 pb-md-10">
  <div class="container py-4 py-md-6">
    <p class="h4">Gracias, tu reclamo ha sido recibido.</p>
    <p>Te responderemos a la brevedad posible.</p>
  </div>
</div>